module.exports = __webpack_public_path__ + "static/media/svg2.d560bf80.svg";